import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';

export const OcurrencesByGenderMonthly = () => {
    const { chartData } = useProfileChartsDataContext();

    return (
        <SimpleBars
            title={'Resultado das ocorrências mensais por gênero'}
            horizontal={false}
            subtitles={chartData?.ocurrencesByGenderMonthly?.categories}
            series={chartData?.ocurrencesByGenderMonthly?.series}
            customColors={['#FF4560','#008FFB', '#00E396']}
            stacked
        />
    );
};